
export const darkText = "#3d3d3d";
export const colorBase = "#334150";
export const colorSuccess2 = "#16D761";
